var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,1.5L13.5,1.5L13.5,3L19.5,3C21.1569,3,22.5,4.34315,22.5,6L22.5,18C22.5,19.6569,21.1569,21,19.5,21L13.5,21L13.5,22.5L10.5,22.5L10.5,21L4.5,21C2.84315,21,1.5,19.6569,1.5,18L1.5,6C1.5,4.34315,2.84315,3,4.5,3L10.5,3L10.5,1.5ZM13.5,18.75L19.5,18.75C19.8682,18.75,20.1744,18.4847,20.2379,18.1348L20.25,18L20.25,6C20.25,5.63181,19.9847,5.32559,19.6348,5.26208L19.5,5.25L13.5,5.25L13.5,18.75Z",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.314a1cfea273ab5497e2fde616d018b2.svg";
export { ForwardRef as ReactComponent };